import { BaseTranslation } from 'src/i18n/i18n-types';

export const comments: BaseTranslation = {
  editor: {
    create: {
      placeholder: 'Add a comment...',
    },
    submit: 'Comment',
  },
  sidebar: {
    title: 'Comments',
    openButtonTitle: 'View comments',
    closeButtonTitle: 'Close',
  },
  list: {
    noComments: 'No comments have been added',
    error: 'Error getting comments',
  },
  history: 'Comment History',
  deleted: 'This comment was deleted by the user.',
  reply: 'Reply',
  replyPlaceholder: 'Reply...',
  modal: {
    allComments: 'All comments',
    openComments: 'Open comments',
    oneReply: '1 reply',
    multipleReplies: '{count} replies',
  },
  deleteModal: {
    title: 'Delete Comment',
    detail: 'Are you sure you want to delete this comment?',
    submitBtn: 'Delete',
    success: 'Successfully deleted comment',
    error: 'Error deleting comment: {error}',
  },
};
